import useBriefContext from '../../Hooks/Brief/useBriefContext'
import isBizBrief from '../../Logic/Form/Sequences/Biz/isBizBrief'
import InputView from '../FormSteps/InputView'
import RecommendationInput from './RecommendationInput'
import LFRecommendationInput from './LeadFeed/LFRecommendationInput'

// Both sequences share the `recommendations` path but not the experience.
const RecommendationStep: InputView = (props): JSX.Element => {
  const { brief } = useBriefContext()

  return isBizBrief(brief) ? (
    <RecommendationInput {...props} />
  ) : (
    <LFRecommendationInput {...props} />
  )
}

export default RecommendationStep
